import locale from "localization";
import moment from "moment";
import Validation from "utils/validation.utils";

const initialState = ({ purchaseOrder }) => {
  const { order } = purchaseOrder || {};

  return {
    recipient: {
      name: "recipient",
      value: order?.recipient || "station",
      label: locale.orderRecipient,
      required: true,
      validations: [Validation.required({ noMessage: true })],
    },
    purchaseOrderNumber: {
      name: "purchaseOrderNumber",
      value: order?.purchaseOrderNumber || "-",
      label: locale.purchaseOrderNo,
      required: false,
    },
    salesOrderNumber: {
      name: "salesOrderNumber",
      value: order?.salesOrderNumber || "-",
      label: locale.salesOrderNo,
      required: false,
    },
    date: {
      name: "date",
      value: order?.preferredDeliveryDate
        ? moment(order?.preferredDeliveryDate).toDate()
        : new Date(),
      label: locale.date,
      required: true,
      placeholder: "DD/MM/YYYY",
      validations: [Validation.required()],
    },
    time: {
      name: "time",
      value: order?.preferredDeliveryDate
        ? moment(order?.preferredDeliveryDate).toDate()
        : new Date(),
      label: locale.time,
      placeholder: "00:00 AM",
      required: true,
      validations: [Validation.required()],
    },
    productType: {
      name: "productType",
      label: locale.productType,
      placeholder: locale.select,
      value: order?.productType || "",
      required: true,
      validations: [Validation.required({ noMessage: true })],
    },
    products: {
      name: "products",
      value:
        order?.orderItems?.length > 0
          ? order?.orderItems.map((item) => {
              let value = {};
              if (order?.productType === "fuel") {
                value = {
                  productCode: item?.productCode,
                  inventoryLevelCm: item?.inventoryLevelCm,
                  inventoryLevelLiter: item?.inventoryLevelLiter,
                  volume: item?.volume,
                  isInventoryFromTotalizer: item?.isInventoryFromTotalizer,
                  totalizerValue: item?.totalizerValue || 0,
                };
              }

              return {
                product: item?.productCode,
                ...value,
              };
            })
          : [],
      required: true,
      validations: [Validation.required(), Validation.requiredArray({ notEmpty: true })],
    },
    remarks: {
      name: "remarks",
      value: order?.remarks || "",
      label: locale.remarks,
      placeholder: locale.sampleRemarks,
      maxLength: 500,
    },
    remarksHo: {
      name: "remarksHo",
      value: order?.remarksHo || "",
      label: locale.headOfficeRemarks,
    },
    productType: {
      name: "productType",
      value: order?.productType || "fuel",
      required: true,
      label: locale.productType,
      validations: [Validation.required()],
    },
  };
};

export default initialState;
